import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift, Headphones, MapPin } from 'lucide-react';
export function IncludedSection() {
  const chapters = ['Momento Sonora + Test del Mercado', '7 Plantas + Rueda de Rotación del Ciclo', 'Matriz de Dosis + Errores Fatales', 'Protocolos Noche 1-4 con Timers', 'Boosters para Estrés Alto', 'Rutina Lockdown 365 Días'];
  const bonuses = [{
    icon: <MapPin className="w-5 h-5" data-id="element-89" />,
    text: 'Lista de mercados específicos (Sonora pasillo 5, Corabastos Bogotá)'
  }, {
    icon: <Headphones className="w-5 h-5" data-id="element-90" />,
    text: 'Audio guía de preparación de té (10 min)'
  }];
  return <section className="py-12 md:py-20 px-4 bg-forest-800" data-id="element-91">
      <div className="max-w-4xl mx-auto" data-id="element-92">
        <div className="text-center mb-8 md:mb-12" data-id="element-93">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gold-500 mb-4" data-id="element-94">
            ¿Qué Incluye Tu Guía?
          </h2>
          <p className="text-cream-300" data-id="element-95">
            Todo lo que necesitas para empezar esta misma noche.
          </p>
        </div>

        <div className="bg-forest-700 rounded-2xl p-5 md:p-12 border border-forest-500 shadow-2xl" data-id="element-96">
          <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-97">
            <div data-id="element-98">
              <h3 className="text-lg md:text-xl font-bold text-cream-100 mb-4 md:mb-6 flex items-center gap-2" data-id="element-99">
                <span className="bg-gold-500 text-forest-900 text-xs px-2 py-1 rounded font-bold" data-id="element-100">
                  PDF eBook
                </span>
                6 Capítulos Completos
              </h3>
              <ul className="space-y-3 md:space-y-4" data-id="element-101">
                {chapters.map((chapter, index) => <motion.li key={index} initial={{
                opacity: 0,
                x: -10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.1
              }} className="flex items-start gap-3" data-id="element-102">
                    <div className="mt-1 bg-green-900/50 rounded-full p-1" data-id="element-103">
                      <Check className="w-4 h-4 text-gold-500" data-id="element-104" />
                    </div>
                    <span className="text-cream-200" data-id="element-105">{chapter}</span>
                  </motion.li>)}
              </ul>
            </div>

            <div className="bg-forest-800/50 rounded-xl p-4 md:p-6 border border-forest-600" data-id="element-106">
              <h3 className="text-lg md:text-xl font-bold text-gold-400 mb-4 md:mb-6 flex items-center gap-2" data-id="element-107">
                <Gift className="w-5 h-5" data-id="element-108" />
                Bonos de Regalo
              </h3>
              <ul className="space-y-4 md:space-y-6" data-id="element-109">
                {bonuses.map((bonus, index) => <li key={index} className="flex items-start gap-4" data-id="element-110">
                    <div className="bg-gold-500/10 p-2 rounded-lg text-gold-500 shrink-0" data-id="element-111">
                      {bonus.icon}
                    </div>
                    <span className="text-cream-200 text-sm font-medium" data-id="element-112">
                      {bonus.text}
                    </span>
                  </li>)}
              </ul>
              <div className="mt-6 md:mt-8 pt-4 md:pt-6 border-t border-forest-600 text-center" data-id="element-113">
                <p className="text-sm text-cream-300 mb-4" data-id="element-114">
                  Disponible inmediatamente en tu email
                </p>
                <div className="inline-block bg-forest-900 px-4 py-2 rounded border border-forest-500 text-xs text-gold-500 font-mono" data-id="element-115">
                  FORMATO DIGITAL (PDF + MP3)
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}